export const extendSessionByThreeHours = (overrideExisting = false) => {
  const current = new Date()
  const targetDate = new Date(current)
  targetDate.setMinutes(targetDate.getMinutes() + 90)

  const existingEt = localStorage.getItem('et')
  const existingActivity = localStorage.getItem('lastActivity')

  if (existingEt && !overrideExisting) {
    const existingEtDate = new Date(existingEt)
    const timeRemaining = existingEtDate.getTime() - current.getTime()
    if (timeRemaining > 0) {
      // If there's still time remaining, don't update the et value
      return
    }
  }

  // If there's no existing 'lastActivity' value or if overrideExisting is true, set a new 'lastActivity' value
  if (!existingActivity || overrideExisting) {
    localStorage.setItem('lastActivity', new Date().toString())
  }

  // If there's no existing et value or it has expired, or if overrideExisting is true, set a new et value
  localStorage.setItem('et', String(targetDate))
}
